export default {"src":"https://cdn.jetlend.ru/_next/static/media/24h-feature.71f7e10e.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};